import { getSettingValue } from './homepageHeroSettings.js';

function normalizeLogoUrl(value) {
  if (typeof value !== 'string') return null;
  const normalized = value.trim();
  return normalized || null;
}

export function getTenantLogoUrl(tenant, variant = 'fullColor') {
  const variants = getSettingValue(tenant, 'branding.logo_variants');
  return (
    normalizeLogoUrl(variants?.[variant]) ||
    normalizeLogoUrl(getSettingValue(tenant, 'tenant.logo_url')) ||
    normalizeLogoUrl(getSettingValue(tenant, 'branding.logo_custom_url')) ||
    normalizeLogoUrl(getSettingValue(tenant, 'branding.logo_light')) ||
    normalizeLogoUrl(getSettingValue(tenant, 'branding.logo_dark'))
  );
}
